module.exports = __webpack_public_path__ + "img/appStore.8416595b.png";